import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import img from "../../Loader/spinner.gif";

function CreaRepositorio(props) {
  const [institucion, setInstitucion] = useState([]);
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerInstituciones",
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const [isLoading, setLoading] = useState(false);
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [archivos, setArchivos] = useState(null);
  const subirArchivos = (e) => {
    setArchivos(e);
  };
  const insertarArchivos = async () => {
    const username = "BasicAuth@icontec.org"; // Replace with your actual username
    const password = "yQLzqmR7eZSuAmQZUqhY"; // Replace with your actual password

    const basicAuth = btoa(`${username}:${password}`);
    const authHeader = `Basic ${basicAuth}`;

    const f = new FormData();
    for (let index = 0; index < archivos.length; index++) {
      f.append("files", archivos[index]);
    }

    try {
      const response = await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/CargaRepositorio?InstitucionId=${institucion}&Ciclo=${postCiclo}&Nombre=${postNombre}&Ano=${postAno}`,
        f,
        {
          headers: {
            Authorization: authHeader,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log(response.data);
      alert("Creado con éxito!");
      window.location.reload("/");
    } catch (error) {
      console.error(error);
      alert("Error al crear");
    }
  };

  const [postCiclo, setPostCiclo] = useState([]);
  const [postNombre, setPostNombre] = useState([]);
  const [postAno, setPostAno] = useState([]);

  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Nueva{" "}
      </button>
      <hr />
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Declaracion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Crear Repositorio
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setInstitucion(e.target.value)}
                        >
                          <option value="">Seleccione la institucion</option>
                          {list.map((item) => (
                            <option value={item.id}>{item.razon_Social}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Año Ejemplo: 2024"
                          onChange={(e) => setPostAno(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setPostCiclo(e.target.value)}
                        >
                          <option value="">Seleccione Ciclo</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                          <option value="13">13</option>
                          <option value="14">14</option>
                          <option value="15">15</option>
                          <option value="16">16</option>
                          <option value="17">17</option>
                          <option value="18">18</option>
                          <option value="19">19</option>
                          <option value="20">20</option>
                        </select>
                      </div>
                      <div className="col-sm-6 ">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Nombre"
                          onChange={(e) => setPostNombre(e.target.value)}
                        />
                      </div>
                    </div>
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <input
                        type="file"
                        name="files"
                        multiple
                        onChange={(e) => subirArchivos(e.target.files)}
                      />
                      <br></br>
                      <hr />
                      {isLoading ? (
                        ""
                      ) : (
                        <button
                          className="btn btn-primary btn-user btn-block"
                          onClick={() => insertarArchivos()}
                        >
                          Guardar
                        </button>
                      )}
                      {isLoading ? (
                        <div>
                          <img
                            style={{ width: "200px", height: "200px" }}
                            src={img}
                          />{" "}
                        </div>
                      ) : (
                        ""
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CreaRepositorio;
